shvenergy.modal = (function ($) {
	"use strict";
    let modalCloseText = "Close";
    var cdnvalue = $("#cdnInput").data("value");
    if (window.globalStrings) {
        modalCloseText = window.globalStrings.modalCloseText;
    }
    const loadingSpinner =
		`<div class="modal-loader">
			<div class="lds-spinner">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>`;

	const modalScaffolding = `<div class="modal-backdrop" role="dialog">
	 <div class="modal">
			<button class="modal-close">
                <span class="modal-close__inner">
                    <span id="modal-close-label">${modalCloseText}</span>
                     <svg focusable="false" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#X_16x16"></use></svg>
                </span>
            </button>
			<div class="modal-content"></div>
		</div>
	</div>`;

    

	const isLoadingStore = {
		isLoadingContent: false,
		isLoadingContentListener: function (val) {},
		set isLoading(val) {
			this.isLoadingContent = val;
			this.isLoadingContentListener(val);
		},
		get isLoading() {
			return this.isLoadingContent;
		},
		registerListener: function (listener) {
			this.isLoadingContentListener = listener;
		}
	};

	isLoadingStore.registerListener(function (val) {

		if (this.isLoading) {
			$(".modal").append($(loadingSpinner).clone());
		} else {
			$(".modal").find(".modal-loader").remove();
		}

	});

    $(document).on("click", ".modal-backdrop", function () {
		hideModal();
	});

    $(document).on("click", ".modal-backdrop .modal-close", function (e) {
		hideModal();
	});

	$(document).on("click", ".modal-backdrop .modal", function (event) {
		event.stopPropagation();
	});

	$(document).on("keydown", function (event) {
		var key = event.keyCode || event.which;
		if (key === 27) {
			hideModal();
		}
	});

    function hideModal() {
		isLoadingStore.isLoading = false;
		$(".modal-backdrop").remove();
		$("html").removeClass("modal-open");
	}

	function showModal(content, options = {}) {
		if (content === null || content === "undefined") {
			console.warn("You need to assign some content to the modal first");
			return;
        } else {
            hideModal();

            var t = $(modalScaffolding).clone();
            t.find(".modal-content").html(content);
            $("body").append(t);
            $("html").addClass("modal-open");

            if (options.extraClass) {
                $(".modal").addClass(options.extraClass);
            }
            if (options.extraBackdropClass) {
                $(".modal-backdrop").addClass(options.extraBackdropClass);
			}

			if (options.moveCloseButtonTo) {
				var closeButton = t.find(".modal-close");
				//closeButton.detach();
				closeButton.appendTo('.modal ' + options.moveCloseButtonTo);
            }
		}

		setTimeout(function() {
			$('.modal').addClass('animated');

			if (options.onShow) {
				options.onShow();
			}

            if (options.focusElement) {
                $('.modal').find(options.focusElement).focus();
            } else {
                $(".modal-close").focus();
            }
		}, 200);
	}

	function replaceModalContent(content) {

		if ($(".modal").length) {
			$(".modal-content").html(content);
		} else {
			console.warn("No modal present on the page in which to replace the content");
		}

	}

	return {
		showModal: showModal,
		hideModal: hideModal,
		replaceModalContent: replaceModalContent,
		isLoadingStore: isLoadingStore
	};

})(jQuery);